import type INavItem from "../../interfaces/INavItem";

const isHrefSelected = (linkHref: string, path: string): boolean => {
  const href = (linkHref ?? "").trim().split(/[?#]/)[0];
  if (!href.startsWith("/")) {
    return false;
  }
  if (href === "/") {
    return path === "/";
  }
  return path === href || path.startsWith(`${href}/`);
};

/**
 * Sets `isSelected` and `hasSelectedChild` on a menu tree for the current route path, in place.
 * An item is selected when its `LinkHref` (query and hash stripped) is the path, or a parent of it
 * ending at a segment boundary. `"/"` matches only the root, and `#`, empty and external links are
 * never selected. `hasSelectedChild` is set when any descendant is selected, so a selected
 * third-level page opens every section above it.
 * @param items the menu items to mark; their sub menus are walked too
 * @param path the route path, without its query string
 * @returns whether any item in the tree is selected
 */
export const markSelectedNavItems = (items: INavItem[], path: string): boolean => {
  let hasSelected = false;
  for (const item of items ?? []) {
    const childSelected =
      Array.isArray(item.SubMenu) && item.SubMenu.length > 0
        ? markSelectedNavItems(item.SubMenu, path)
        : false;
    item.hasSelectedChild = childSelected;
    item.isSelected = isHrefSelected(item.LinkHref, path);
    hasSelected = hasSelected || childSelected || item.isSelected;
  }
  return hasSelected;
};
